import React from 'react'

export default function Footer() {
  return (
    <div className='font-quicksand font-semibold text-center border-t p-10 mt-10 border-gray-200 dark:border-gray-700'>
      <h1>2022 Enceladus. Made with ❤ by <a href="https://github.com/dafaarmanto" className='hover:underline' target="_blank" rel="noreferrer">Dafa Armanto</a></h1>
    </div>
  )
}
